import {useId,View} from "vritra";
import css from "./CounterView.module.css";


export default function CounterView(props){
    const {parent,id=useId("counterview")}=props;
    const counterview=View({parent,id,className:css.counterview}),state={
        count:20,
    };

    counterview.innateHTML=`
        <button ref="decreasebtn">-</button>
        <span ref="countEl" class="${css.count}">${state.count}</span>
        <button ref="increasebtn">+</button>
    `;

    const {increasebtn,decreasebtn,countEl}=counterview;
    decreasebtn.onclick=()=>{
        state.count--;
        countEl.innerHTML=state.count;
    }
    increasebtn.onclick=()=>{
        state.count++;
        countEl.innerHTML=state.count;
    }

    return counterview;
}
